import React from 'react';
import { connect } from 'react-redux';
import Account from '../account/Account';
import LanguageSwitcher from '../language/LanguageSwitcher';
import HelpModal from '../../modal/help/HelpModal';
import Notification from '../notification/Notification';

import { getProfile } from '../../redux/profile/profile_actions';
import { hideSideMenu, showSideMenu } from '../../redux/app/app_actions';

import './Topbar.css';

class Topbar extends React.Component {
  componentDidMount() {
    this.props.getProfile();
  }

  onToggleHandler() {
    if (this.props.isShowSideMenu) {
      this.props.hideSideMenu();
    } else {
      this.props.showSideMenu();
    }
  }

  onNavigate({ submission_id, project_id }) {
    let path = '';
    if (this.props.isInspector) {
      path = `/project_inspections/${submission_id}`;
    } else {
      path = `/projects/${project_id}`;
    }
    this.props.history.push(path);
  }

  render() {
    const help = this.props.help;
    return (
      <div className="topbar">
        <ul className="nav navbar-left">
          <li>
            <a href="#" onClick={() => this.onToggleHandler()}>
              <i className="fas fa-bars" />
            </a>
          </li>
          {this.props.renderActionMenu ? this.props.renderActionMenu() : null}
        </ul>
        <ul className="nav navbar-right">
          <li>
            <LanguageSwitcher />
          </li>
          <li>
            <Notification onNotificationClick={extra => this.onNavigate(extra)} />
          </li>
          {!!help ? (
            <li>
              <HelpModal {...help} />
            </li>
            ) : null
          }
          <li>
            <Account />
          </li>
        </ul>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isShowSideMenu: state.app.isShowSideMenu,
  isInspector: state.authentication.isInspector,
});

const mapDispatchToProps = dispatch => ({
  getProfile: () => dispatch(getProfile()),
  showSideMenu: () => dispatch(showSideMenu()),
  hideSideMenu: () => dispatch(hideSideMenu()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Topbar);



// WEBPACK FOOTER //
// ./src/components/topbar/Topbar.js